// Func = limiting Scope for this file
let lastScrollTop = 0;
let timeout;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function resizeWindow(){

}

(function(){

	window.addEventListener('resize', () => {
		resizeWindow();
		
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	
	// FORM focus animation - floating labels
	if(document.querySelectorAll('.form-module__field:not(.gdpr)').length > 0){
		document.querySelectorAll('.form-module__field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}
	if(document.querySelectorAll('#email-signup .field:not(.gdpr)').length > 0){
		document.querySelectorAll('#email-signup .field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}

})();

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down'))  {
			document.getElementById('header').classList.add('down');
			
		}
	} else {
		if(document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('down');
			
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

document.addEventListener('DOMContentLoaded', function() {
  const skipNav = document.querySelector('nav#nav-skip');
  if (skipNav) {
    document.body.insertBefore(skipNav, document.body.firstChild);
  }
});